module.exports = __webpack_public_path__ + "img/bullhorn-black.07d77cda.png";